(function () {
  'use strict';
  function svg(tag, attrs) {
    var node = document.createElementNS('http://www.w3.org/2000/svg', tag);
    Object.keys(attrs || {}).forEach(function (key) { node.setAttribute(key, attrs[key]); });
    return node;
  }
  function mount(anchor, scale, angle) {
    var a = scale * Math.cos(angle), b = scale * Math.sin(angle);
    return [a, b, -b, a, -a * anchor[0] + b * anchor[1], -b * anchor[0] - a * anchor[1]];
  }
  function apply(m, p) { return [m[0] * p[0] + m[2] * p[1] + m[4], m[1] * p[0] + m[3] * p[1] + m[5]]; }
  // Original Panda Podium photographs. The SVG viewport isolates the front
  // head; its machining, socket, engraving and finish stay photographic.
  var CYBREI_BOLTS = {
    Negro: { src: 'cbv-cybrei-bolt-black.png', crop: [230, 214, 307, 320] },
    Azul: { src: 'cbv-cybrei-bolt-blue.png', crop: [265, 223, 305, 322] },
    Gold: { src: 'cbv-cybrei-bolt-gold.png', crop: [255, 260, 309, 322] },
    Cooper: { src: 'cbv-cybrei-bolt-copper.png', crop: [196, 173, 353, 356] },
    Rosa: { src: 'cbv-cybrei-bolt-pink.png', crop: [206, 244, 306, 311] },
    Morado: { src: 'cbv-cybrei-bolt-purple.png', crop: [190, 191, 330, 343] },
    Rojo: { src: 'cbv-cybrei-bolt-red.png', crop: [277, 260, 278, 289] },
    Plata: { src: 'cbv-cybrei-bolt-silver.png', crop: [288, 283, 316, 313] },
  };
  function cybreiBoltDefs(photo) {
    var defs = svg('defs'), c = photo.crop;
    var clip = svg('clipPath', { id: 'cb-cybrei-photo-head', clipPathUnits: 'userSpaceOnUse' });
    clip.appendChild(svg('ellipse', { cx: c[0] + c[2] / 2, cy: c[1] + c[3] / 2, rx: c[2] / 2, ry: c[3] / 2 }));
    defs.appendChild(clip);
    return defs;
  }
  function cybreiBolt(point, radius, photo, href) {
    var head = svg('g', { transform: 'translate(' + point.join(' ') + ')', 'data-cb-bolt-head': 'cybrei' });
    var viewport = svg('svg', { x: -radius, y: -radius, width: radius * 2, height: radius * 2,
      viewBox: photo.crop.join(' '), preserveAspectRatio: 'none', overflow: 'hidden' });
    viewport.appendChild(svg('image', { href: href, width: 1500, height: 1500,
      'clip-path': 'url(#cb-cybrei-photo-head)', 'data-cb-bolt-photo': photo.src }));
    head.appendChild(viewport);
    return head;
  }
  function create(opts) {
    var V = opts.visual, C = opts.catalog, R = opts.rules;
    var MAP = V.map, L = V.layers, PXMM = V.pxPerMm;
    var base = opts.assetBase || '/assets/';
    var title = opts.title || function (h) { return (C.parts[h] && C.parts[h].t) || h; };
    function optValue(h, S, name) {
      var p = C.parts[h]; if (!p || !name) return null;
      var i = p.opts.indexOf(name);
      return i < 0 ? null : ((S.sel[h] || [])[i] || null);
    }
    function firstValue(h, name) {
      var p = C.parts[h]; if (!p) return null;
      var i = p.opts.indexOf(name);
      return i < 0 || !p.vs.length ? null : p.vs[0][2 + i];
    }
    function teethOf(v) { var m = /(\d{2})/.exec(v || ''); return m ? +m[1] : null; }
    function gearing(v) {
      var m = /(\d{2})\s*[\/-]\s*(\d{2})/.exec(v || '');
      if (m) return m[1] + '/' + m[2] + 'T';
      var t = teethOf(v); return t ? t + 'T' : '';
    }
    function mmOf(v) { var m = /(\d+(?:[.,]\d+)?)\s*mm/.exec(v || ''); return m ? parseFloat(m[1].replace(',', '.')) : null; }
    function byOption(h, S, m) {
      if (m.layer) return m.layer;
      var v = optValue(h, S, m.by);
      return m.layers[v] || m.layers[firstValue(h, m.by)] || m.layers[Object.keys(m.layers)[0]];
    }
    function pitch(teeth) { return PXMM * 12.7 / (2 * Math.sin(Math.PI / teeth)); }

    function plan(S) {
      var out = { S: S, spindle: S.spindle || null, arm: null, spider: null, rings: null, bolts: null, bb: null };
      if (S.crank) {
        var cm = MAP.crank[S.crank], lay = cm && L[cm.layer];
        var len = mmOf(optValue(S.crank, S, MAP.lengthOption)) || 170;
        out.arm = { handle: S.crank, id: cm ? cm.layer : null, layer: lay, len: len, chosenLen: !!optValue(S.crank, S, MAP.lengthOption) };
        if (lay) {
          var dx = lay.pedal[0] - lay.anchor[0], dy = lay.pedal[1] - lay.anchor[1];
          out.arm.m = mount(lay.anchor, PXMM * len / Math.hypot(dx, dy), -Math.atan2(dy, dx));
          out.arm.tip = PXMM * len;
        }
      }
      var ringHandle = null, ringMap = null, direct = false;
      if (S.spider) {
        var sm = MAP.spider[S.spider];
        if (sm && sm.direct) { ringHandle = S.spider; ringMap = sm; direct = true; }
        else {
          var sl = sm && L[sm.layer];
          var inc = C.parts[S.spider] && C.parts[S.spider].spec && C.parts[S.spider].spec.includes;
          out.spider = { handle: S.spider, id: sm ? sm.layer : null, layer: sl, pm: !!(inc && inc.pm) };
        }
      }
      if (!direct && S.rings) { ringHandle = S.rings; ringMap = MAP.rings[S.rings]; }
      if (ringHandle) {
        var rid = ringMap ? byOption(ringHandle, S, ringMap) : null, rl = rid && L[rid];
        var tv = ringMap ? (optValue(ringHandle, S, ringMap.teeth) || firstValue(ringHandle, ringMap.teeth)) : null;
        var teeth = teethOf(tv) || 50;
        out.rings = { handle: ringHandle, id: rid, layer: rl, teeth: teeth, gearing: gearing(tv), direct: direct, radius: pitch(teeth) };
        if (rl) out.rings.m = mount(rl.anchor, out.rings.radius / rl.radius, rl.rotate || 0);
      }
      if (out.spider && out.spider.layer) {
        var sp = out.spider.layer, rg = out.rings && out.rings.layer;
        if (rg && rg.bolts && sp.bolts && !out.rings.direct) {
          // The studio's fit: the similarity that best lays the spider's bolt
          // holes onto the chainring's (least squares about the spindle).
          var targets = rg.bolts.map(function (p) { return apply(out.rings.m, p); });
          var den = 0, u = 0, v = 0;
          sp.bolts.forEach(function (p, i) {
            var x = p[0] - sp.anchor[0], y = p[1] - sp.anchor[1], tX = targets[i][0], tY = targets[i][1];
            den += x * x + y * y; u += x * tX + y * tY; v += x * tY - y * tX;
          });
          u /= den; v /= den;
          out.spider.m = mount(sp.anchor, Math.hypot(u, v), Math.atan2(v, u));
        } else out.spider.m = mount(sp.anchor, sp.scale, sp.rotate || 0);
      }
      // Chainring bolts: drawn on the spider's bolt holes once there is a
      // chainring for them to hold. Photographed bolt heads are kept unless a
      // coloured kit replaces them; empty photographed holes always get one.
      if (out.spider && out.spider.m && out.rings && !out.rings.direct) {
        var kit = S.bolts && MAP.bolts[S.bolts], finish = kit ? optValue(S.bolts, S, kit.by) || firstValue(S.bolts, kit.by) : null;
        var colour = kit ? kit.colors[finish] : null;
        var spl = out.spider.layer;
        if (colour || spl.boltHeadRadius || !spl.photoBolts) {
          var sc = Math.hypot(out.spider.m[0], out.spider.m[1]);
          out.bolts = {
            pts: spl.bolts.map(function (p) { return apply(out.spider.m, p); }),
            r: spl.boltHeadRadius ? spl.boltHeadRadius * sc : 4.6,
            colour: colour || '#2c2e31',
            cybrei: S.bolts === 'cybrei-2x-chairing-bolt-kit',
            photo: CYBREI_BOLTS[finish],
          };
        }
      }
      if (S.bb) {
        var bm = MAP.bb[S.bb];
        out.bb = { handle: S.bb, id: bm ? bm.layer : null, layer: bm && L[bm.layer] };
      }
      out.ringR = out.rings ? out.rings.radius : pitch(50);
      out.spindleR = (MAP.spindleMm[S.spindle] || 28.99) * PXMM / 2;
      return out;
    }

    function renderFlat(target, S) {
      var flat = plan(S);
      var names = ['rings', 'spider', 'arm'];
      var layers = names.filter(function (name) { return flat[name] && flat[name].layer; });
      if (!flat.arm || !flat.arm.layer || !flat.rings || !flat.rings.layer ||
          (flat.spider && !flat.spider.layer)) return Promise.reject(new Error('Missing assembly image'));
      if (flat.bolts && flat.bolts.cybrei && !flat.bolts.photo) return Promise.reject(new Error('Missing bolt finish image'));
      function loadImage(src) {
        var img = new Image();
        return new Promise(function (resolve, reject) {
          img.onload = resolve; img.onerror = function () { reject(new Error('Assembly image unavailable')); };
          img.src = src;
        });
      }
      var bounds = [-flat.ringR, -flat.ringR, flat.ringR, flat.ringR];
      layers.forEach(function (name) {
        var d = flat[name], l = d.layer;
        [[0, 0], [l.w, 0], [0, l.h], [l.w, l.h]].forEach(function (corner) {
          var p = apply(d.m, corner);
          bounds[0] = Math.min(bounds[0], p[0]); bounds[1] = Math.min(bounds[1], p[1]);
          bounds[2] = Math.max(bounds[2], p[0]); bounds[3] = Math.max(bounds[3], p[1]);
        });
      });
      var width = bounds[2] - bounds[0], height = bounds[3] - bounds[1];
      var pad = Math.max(width, height) * .12;
      var drawing = svg('svg', {
        viewBox: [bounds[0] - pad, bounds[1] - pad, width + pad * 2, height + pad * 2].join(' '),
        role: 'img', 'aria-label': opts.label + ': ' + R.summary(S).lines.map(function (line) {
          return title(line.handle) + (line.sub ? ' (' + line.sub + ')' : '');
        }).join(', '),
        class: 'cb-final__image', width: '1200', height: '640',
      });
      var overfastNormal = flat.rings.id === 'rings-overfast-normal';
      if (overfastNormal) {
        var pair = /(\d+)\s*[\/-]\s*(\d+)/.exec(flat.rings.gearing);
        var smallTeeth = pair ? +pair[2] : 34;
        var smallRadius = pitch(smallTeeth), path = '';
        for (var tooth = 0; tooth < smallTeeth * 4; tooth++) {
          var angle = tooth * Math.PI * 2 / (smallTeeth * 4);
          var radius = smallRadius + (tooth % 4 === 1 || tooth % 4 === 2 ? 2 : -1.5);
          path += (tooth ? 'L' : 'M') + (Math.cos(angle) * radius) + ' ' + (Math.sin(angle) * radius);
        }
        var bore = PXMM * 42;
        path += 'Z M' + bore + ' 0 A' + bore + ' ' + bore + ' 0 1 0 ' + (-bore) + ' 0 A' + bore + ' ' + bore + ' 0 1 0 ' + bore + ' 0Z';
        drawing.appendChild(svg('path', { d: path, fill: '#18191b', stroke: '#515459',
          'stroke-width': '.7', 'fill-rule': 'evenodd', 'data-cb-flat-part': 'inner-ring',
          'data-cb-flat-teeth': smallTeeth }));
      }
      var loaded = layers.map(function (name) {
        var d = flat[name], l = d.layer;
        var href = base + l.src;
        var photo = svg('image', {
          href: href, width: l.w, height: l.h,
          transform: 'matrix(' + d.m.join(' ') + ')', 'data-cb-flat-part': name,
          'data-cb-flat-layer': d.id, 'data-cb-flat-handle': d.handle,
        });
        // Keep donor-photo remnants outside the selected ring's spider crop
        // from covering its face. The source image and mounting stay intact.
        var spiderClip = name === 'spider' && flat.rings && flat.rings.layer.spiderClips && flat.rings.layer.spiderClips[d.id];
        if (spiderClip) {
          var clipDefs = svg('defs'), clipId = 'cb-flat-ring-spider-clip';
          var clip = svg('clipPath', { id: clipId, clipPathUnits: 'userSpaceOnUse' });
          clip.appendChild(svg('path', { d: spiderClip }));
          clipDefs.appendChild(clip); drawing.appendChild(clipDefs);
          photo.setAttribute('clip-path', 'url(#' + clipId + ')');
        }
        if (name === 'rings' && overfastNormal) {
          var defs = svg('defs'), maskId = 'cb-flat-overfast-aperture';
          var mask = svg('mask', { id: maskId, maskUnits: 'userSpaceOnUse', x: 0, y: 0, width: l.w, height: l.h });
          mask.appendChild(svg('circle', { cx: l.anchor[0], cy: l.anchor[1], r: l.radius + 7, fill: '#fff' }));
          mask.appendChild(svg('circle', { cx: l.anchor[0], cy: l.anchor[1], r: 159, fill: '#000' }));
          l.bolts.forEach(function (bolt) {
            var x = bolt[0] - l.anchor[0], y = bolt[1] - l.anchor[1], r = Math.hypot(x, y);
            var dx = x / r, dy = y / r, side = 22;
            var polygon = [[bolt[0] - dy * side, bolt[1] + dx * side], [l.anchor[0] + dx * 176 - dy * side, l.anchor[1] + dy * 176 + dx * side],
              [l.anchor[0] + dx * 176 + dy * side, l.anchor[1] + dy * 176 - dx * side], [bolt[0] + dy * side, bolt[1] - dx * side]];
            mask.appendChild(svg('polygon', { points: polygon.map(function (p) { return p.join(','); }).join(' '), fill: '#fff' }));
            mask.appendChild(svg('circle', { cx: bolt[0], cy: bolt[1], r: 23, fill: '#fff' }));
          });
          defs.appendChild(mask); drawing.appendChild(defs);
          photo.setAttribute('mask', 'url(#' + maskId + ')');
        }
        drawing.appendChild(photo);
        return loadImage(href);
      });
      if (flat.bolts) {
        var bolts = svg('g', { 'data-cb-flat-part': 'bolts', 'data-cb-flat-color': flat.bolts.colour });
        if (flat.bolts.cybrei) {
          drawing.appendChild(cybreiBoltDefs(flat.bolts.photo));
          loaded.push(loadImage(base + flat.bolts.photo.src));
        }
        flat.bolts.pts.forEach(function (p) {
          if (flat.bolts.cybrei) { bolts.appendChild(cybreiBolt(p, flat.bolts.r, flat.bolts.photo, base + flat.bolts.photo.src)); return; }
          bolts.appendChild(svg('circle', { cx: p[0], cy: p[1], r: flat.bolts.r,
            fill: flat.bolts.colour, stroke: '#111', 'stroke-width': '.8' }));
          bolts.appendChild(svg('circle', { cx: p[0], cy: p[1], r: flat.bolts.r * .37,
            fill: '#151619', stroke: '#65686c', 'stroke-width': '.4' }));
        });
        drawing.insertBefore(bolts, drawing.querySelector('[data-cb-flat-part="arm"]'));
      }
      if (flat.arm.layer.cavity) drawing.insertBefore(svg('circle', {
        cx: 0, cy: 0, r: flat.spindleR * .62, fill: '#161719',
      }), drawing.querySelector('[data-cb-flat-part="arm"]'));
      return Promise.all(loaded).then(function () {
        target.replaceChildren(drawing);
        return drawing;
      });
    }

    return { render: renderFlat };
  }
  window.CBFlat = { create: create };
})();
